import { Input } from "@/components/ui/input";

interface ValueInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function ValueInput({ value, onChange }: ValueInputProps) {
  return (
    <div>
      <label className="text-sm font-medium text-manuscript-primary mb-2 block">
        Enter Value
      </label>
      <Input
        type="number"
        placeholder="Enter value to convert"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full"
      />
    </div>
  );
}